import { __read } from "tslib";
import { useMemo, useReducer } from 'react';
import { BannerActionType, BannerReducer } from '../store';
export var useBannerStore = function () {
    var _a = __read(useReducer(BannerReducer, {
        banners: [],
    }), 2), bannerState = _a[0], dispatch = _a[1];
    var setBannerState = useMemo(function () {
        return {
            addBanner: function (banner) {
                dispatch({ type: BannerActionType.addBanner, banner: banner });
            },
            removeBanner: function (id) {
                dispatch({ type: BannerActionType.removeBanner, id: id });
            },
        };
    }, [dispatch]);
    return [bannerState, setBannerState];
};
//# sourceMappingURL=useBannerStore.js.map